<template>
  <PopUp
    unbottom
    :title="title"
    :isLoading="isLoading.popup"
    :popUpActive="isActive.popup"
    @click="$_onClosePopup('popup')"
  >
    <LlCancelPopupContent>
      <template v-slot:buttons>
        <WsButton001
          outLine
          @click="$_onClosePopup('popup')"
        >
          {{ $t('取消') }}
        </WsButton001>
        <WsButton001
          :isloading="isLoading.delete"
          :disable="isLoading.delete"
          @click="$_onDelete()"
        >
          {{ $t('確定') }}
        </WsButton001>
      </template>
    </LlCancelPopupContent>
  </PopUp>
</template>

<script>
import S_file from '@/service/api/v1/file';
import Spare_file from '@/spare/file';

export default {
  props: {
    id: {
      type: String,
    },
    module: {
      type: String,
    },
  },
  data() {
    return {
      isActive: {
        popup: false,
      },
      isLoading: {
        popup: false,
        delete: false,
      },
      title: '',
      isDeletable: false,
    };
  },
  watch: {
    'isActive.popup': {
      async handler(newVal) {
        if (newVal) await this.$_onCheckDeleteStatus();
      }
    }
  },
  methods: {
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
      if (type === 'popup') {
        this.title = '';
        this.isDeletable = false;
      }
    },
    $_onRemoveFile() {
      this.$emit('remove');
      this.$_onClosePopup('popup');
    },
    async $_onDelete() {
      this.isLoading.delete = true;
      if (this.isDeletable) await S_file.deleteFile(this.id ,this.module);
      this.isLoading.delete = false;
      this.$_onRemoveFile();
    },
    async $_onCheckDeleteStatus() {
      this.isLoading.popup = true;
      if (!this.id) {
        this.title = Spare_file.warning.noScopeAndRemove;
      } else {
        const message = await S_file.checkDeleteScope(this.id ,this.module);
        switch (message) {
          case 'file can delete':
            this.title = Spare_file.warning.removeAndDelete;
            this.isDeletable = true;
            break;
          case 'file is used':
            this.title = Spare_file.warning.usedAndRemove;
            break;
          case 'invalid scopes':
            this.title = Spare_file.warning.noScopeAndRemove;
            break;
        }
      }
      this.isLoading.popup = false;
    }
  }
}
</script>